import Vue from "vue";
import vuex from "vuex";
import axios from "axios";
Vue.use(vuex);

export default new vuex.Store({
  state: {
    allData: "",
    languagesData: "",
    languages: "traditional",
    highlight: "index",
  },
  mutations: {
    languagesDataFun(state, data) {
      state.allData = data;
      state.languagesData = data[state.languages];
    },
    changeLanguage(state, language) {
      state.languages = language;
      state.languagesData = state.allData[language];
    },
  },
  getters: {},
  actions: {
    async getlanguageData(type) {
      return new Promise((resolve) => {
        axios.get("./static/language.json").then((res) => {
          // console.log(res);
          this.commit("languagesDataFun", res.data.data);
          resolve(res);
        });
      });
    },
  },
  modules: {},
});



// WEBPACK FOOTER //
// ./src/store/index.js